<template>
  <div class="zv-page">
    <div class="zv-content">
      <!-- <div class="zv-block" style="display:flex">
        <div class="block" style="margin-left:20px;display:flex">
          <span class="countryName">分类</span>
          <el-input placeholder="输入关键字" v-model="countryName" clearable></el-input>
        </div>

        <div style="margin-left:20px">
          <el-row>
            <el-button type="success" @click="queryData()">查询</el-button>
            <el-button type="primary">导出</el-button>
          </el-row>
        </div>
      </div> -->
      <el-button type="success" style="margin:10px 0" @click="addResponseLibraryData()">新增条目</el-button>
      <el-table
        :data="tableData"
        style="width: 100%"
        default-expand-all
        row-key="id"
        :tree-props="{children: 'child', hasChildren: 'hasChild'}"
        :default-sort="{prop: 'date', order: 'descending'}"
      >
        <el-table-column prop="id" label="编号"></el-table-column>
        <el-table-column prop="level" label="分类等级">
          <template slot-scope="scope">
            <span>{{scope.row.level == 1 ? '一级': scope.row.level == 2 ? '二级':'三级'}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="category_name" label="分类名称"></el-table-column>
        <el-table-column prop="add_time" label="创建时间" sortable>
          <template slot-scope="scope">
            <span>{{$commFunc.formatDate(scope.row.add_time)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="update_time" label="最后更新" sortable>
          <template slot-scope="scope">
            <span>{{$commFunc.formatDate(scope.row.update_time)}}</span>
          </template>
        </el-table-column>
        <el-table-column prop="last_admin_username" label="操作人">
          <template slot-scope="scope">
            <span>{{scope.row.last_admin_username || '--'}}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="addResponseLibraryData(scope.row,2)">
              <i class="el-icon-edit"></i>编辑
            </el-button>
            <el-button v-if="scope.row.level != 3" type="text" size="small" @click="addResponseLibraryData(scope.row,1)">
              <i class="el-icon-add"></i>新增子分类
            </el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>

    <!-- <div class="pagination">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 50, 100]"
        :page-size="10"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalList"
      ></el-pagination>
    </div> -->
  </div>
</template>

<script>
import api from "./api";

export default {
  name: "ResponseLibrary",
  data() {
    return {
      addressSelectData: null,
      addressItem: null,
      countryName: "",
      tableData: [],
      currentPage: 1,
      totalList: null
    };
  },
  created() {
    this.getData({parent_id: 0});
  },
  methods: {
    // 获取数据
    getData(data) {
      api
        .categoryList(data)
        .then(res => {
          // this.$message("请求成功!");
          this.tableData = res.list;
          this.totalList = res.recordcount;
          this.pageSize = res.pagecount;
          // console.log(res);
        })
        .catch(err => {
          // console.log(err);
        });
    },

    // 查询参数
    queryData() {
      debugger;
      let data = {
        q: this.countryName
      };
      if (data.q) {
        this.getData(data);
      } else {
        this.getData();
      }
    },

    // 新增数据
    addResponseLibraryData(row,index) {
      let routeData = this.$router.resolve({
        name: "addCategory",
        query: {
          parent_id: index == 1 ? row.id: false,
          add: index == 1? 1:0,
          editId: index == 1? row.id:row ? row.id : false,
          name: index == 2? row.category_name: false
        }
      });
      window.open(routeData.href, '_blank');
    },

    // 删除数据
    deleteData(row) {
      let data = {
        id: row.id
      };
      this.$confirm("确定删除该条记录？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(() => {
          this.delete(data);
        })
        .catch(() => {});
    },

    delete(data) {
      api
        .recordedDelete(data)
        .then(res => {
          this.$message({
            message: "删除成功！",
            type: "success"
          });
          this.getData();
        })
        .catch(err => {});
    },

    //改变每页显示数量重新请求数据，重置当前页为第一页
    handleSizeChange(val) {
      let pageSize = { pagesize: val };
      this.getData(pageSize);
    },

    //点击改变当前页
    handleCurrentChange(val) {
      let page = { page: val };
      this.getData(page);
    }
  }
};
</script>

<style lang="scss" scoped>
.pagination {
  text-align: right;
  padding: 0 20px;
}
.countryName {
  margin-right: 10px;
  width: 40px;
  justify-content: center;
  align-items: center;
  display: flex;
}
</style>